import type { IFixitAPIClient } from '@ifixit/ifixit-api-client';

/**
 * An API client for a page script. It sends the `Api-Client` header that the
 * MooTools API class sent, which the Varnish API stats count requests by.
 * Make one per request: IFixitAPIClient.activeRequests is keyed by client, so
 * a shared one drops a request from WebDriver's waitForRequest() while
 * another is still running.
 *
 * The client loads on first use. Imported up front it added 17.6 KiB to every
 * device page, for a workbench button most visits never click.
 */
export async function webApiClient(): Promise<IFixitAPIClient> {
   const { IFixitAPIClient: Client } = await import('@ifixit/ifixit-api-client');
   return new Client({
      origin: window.location.origin,
      headers: { 'Api-Client': 'iFixit-Web' },
   });
}

export function jsonBody(data: unknown): RequestInit {
   return {
      body: JSON.stringify(data),
      headers: { 'Content-Type': 'application/json' },
   };
}
